import { checkUserPermissionFunc } from "../components/common/CommonFunctions";
import ToastMsg from "../components/common/ToastMsg";

export const EMPLOYEE_PROFILE_SECTIONS = [
    { key: "personal", label: "Personal details" },
    { key: "professional", label: "Professional details" },
    { key: "login", label: "Login details" },
    { key: "bank", label: "Bank / account details" },
    { key: "assets", label: "Asset details" },
    { key: "documents", label: "Document details" },
    { key: "salary", label: "Salary details" },
];

const emptyAccess = () => (
    EMPLOYEE_PROFILE_SECTIONS.reduce((acc, section) => {
        acc[section.key] = { view: false, edit: false };
        return acc;
    }, {})
);

const fullAccess = () => (
    EMPLOYEE_PROFILE_SECTIONS.reduce((acc, section) => {
        acc[section.key] = { view: true, edit: true };
        return acc;
    }, {})
);

export const readEmployeeProfileAccess = () => {
    const isSuperAdmin = JSON.parse(sessionStorage.getItem("is_super_admin") || "false");
    const isSystemAdmin = JSON.parse(sessionStorage.getItem("is_system_admin") || "false");
    if (isSuperAdmin || isSystemAdmin) return fullAccess();

    let stored = {};
    try {
        stored = JSON.parse(sessionStorage.getItem("employeeProfileAccess") || "{}") || {};
    } catch {
        stored = {};
    }

    const employees = checkUserPermissionFunc("employee", "employees", "SubMenu");
    const base = (!stored || Object.keys(stored).length === 0) && employees.edit
        ? fullAccess()
        : emptyAccess();

    EMPLOYEE_PROFILE_SECTIONS.forEach(({ key }) => {
        const node = stored[key];
        if (!node || typeof node !== "object") return;
        const edit = !!node.edit;
        base[key] = { view: !!(node.view || edit), edit };
    });
    return base;
};

export const canAccessEmployeeProfile = (section, action = "view") => {
    const access = readEmployeeProfileAccess();
    const node = access[section] || { view: false, edit: false };
    if (action === "edit") return !!node.edit;
    return !!(node.view || node.edit);
};

export const hasAnyEmployeeProfileView = () => (
    EMPLOYEE_PROFILE_SECTIONS.some(({ key }) => canAccessEmployeeProfile(key, "view"))
);

export const hasAnyEmployeeProfileEdit = () => (
    EMPLOYEE_PROFILE_SECTIONS.some(({ key }) => canAccessEmployeeProfile(key, "edit"))
);

export const normalizeEmployeeProfileAccess = (raw) => {
    const next = emptyAccess();
    EMPLOYEE_PROFILE_SECTIONS.forEach(({ key }) => {
        const node = raw?.[key];
        const edit = !!node?.edit;
        next[key] = { view: !!(node?.view || edit), edit };
    });
    return next;
};

export const listDeniedEmployeeProfileSections = (action = "view", keys) => {
    const allowed = Array.isArray(keys) && keys.length
        ? keys
        : EMPLOYEE_PROFILE_SECTIONS.map(({ key }) => key);
    return EMPLOYEE_PROFILE_SECTIONS.filter(
        ({ key }) => allowed.includes(key) && !canAccessEmployeeProfile(key, action)
    );
};

export const employeeProfileDeniedMessage = (action = "view", keys) => {
    const denied = listDeniedEmployeeProfileSections(action, keys);
    if (!denied.length) return "";
    const verb = action === "edit" ? "edit" : "view";
    if (denied.length === 1) {
        return `You don't have permission to ${verb} ${denied[0].label.toLowerCase()}.`;
    }
    return `You don't have permission to ${verb}: ${denied.map(({ label }) => label).join(", ")}.`;
};

const recentAccessToasts = new Map();

export const notifyEmployeeProfileAccessDenied = (action = "view", keys) => {
    const message = employeeProfileDeniedMessage(action, keys);
    if (!message) return "";
    const now = Date.now();
    const lastShown = recentAccessToasts.get(message) || 0;
    if (now - lastShown < 4000) return message;
    recentAccessToasts.set(message, now);
    ToastMsg("warning", message);
    return message;
};
